import { SimpliCitySDK } from "cms/sdk";
import { useAuth } from "cms/auth/hooks/useAuth";
import { useEffect, useState } from "react";
import { parentsToCrumbs } from "cms/shared/breadcrumb/parents-to-crumbs";
import { Logger } from "cms/utils/logger";

// NOTE: not in use - same as standard version
export const useFetchBreadcrumbs = (webpage,model) => {

    const { guid: webpage_guid } = webpage || {};
    const { type } = model || {};
    const { token } = useAuth();

    /** @type {import('./breadcrumb-list').Crumb[]} */
    const defaultCrumbs = [];

    const [crumbs, setCrumbs] = useState(defaultCrumbs);
    const [error, setError] = useState();

    async function fetchData (token, webpage_guid) {
        try {
            let parents = await SimpliCitySDK.webpage.findParents(token, webpage_guid);

            if (parents) {
                // console.log('Set - WEBPAGE')
                if (webpage.layout === "two-column-nav-mydnv") {
                    // remove "Home" from breadcrumbs on MyDNV page only
                    parents.pop();
                }
                parents = parents.reverse();
                parents.pop(); // remove self

                const crumbs = parentsToCrumbs(parents);
                Logger.debug(`breadcrumbs for ${webpage_guid} => ${JSON.stringify(crumbs)}`);
                setCrumbs(crumbs);
            }
        } catch (error) {
            Logger.error(error);
            setError(error);
        }
    }

    useEffect(() => {
        let data;
        if (type === "model.news") {
            data = [{ path: "/", title: "Home" }, { title: "News", path: "/news" }];

        } else if (type === "model.notice") {
            data = [{ path: "/", title: "Home" }, { title: "Advisories", path: "/advisories" }];

        } else if (type === "model.alert") {
            data = [{ path: "/", title: "Home" }, { title: "Alerts", path: "/alerts" }];

        } else if (type === "model.story") {
            data = [{ path: "/", title: "Home" }, { title: "Stories", path: "/dnv-stories" }];

        } else if (type === "model.meeting") {
            // Yes Meetings do use events navigation
            data = [{ path: "/", title: "Home" }, { title: "Events", path: "/events" }];

        } else if (type === "model.event") {
            data = [{ path: "/", title: "Home" }, { title: "Events", path: "/events" }];

        } 

        if (data) {
            setCrumbs(data);
        } else {
            fetchData(token, webpage_guid);
        }

    }, [token, webpage_guid, type]);

    return {
        crumbs,
        error
    };
};

